import React from "react";
import StarBG from "./rsc/Stars.jpg";
import "./Home.css";

export default class Interstitial extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return (
            <div className="interstitial" style={{ position: "relative", textAlign: "center", height: (this.props.children == null ? "10vh" : "auto")}}>{this.props.children}</div>
        );
    }
}